import { MaterialFactorContainer } from './materialFactorTable'

export const MaterialFactorScreen = () => {
  return (
    <>
      <MaterialFactorContainer />
    </>
  )
}
